module.exports = __webpack_public_path__ + "media/stylesheets/images/SAReye-Main-OFFICIAL-RGB-transparent_96-318778bb5f3b08fb9c9eec2685b99586.png";